/**
 * AppBar constants
 */

// Width values for the AppBar
export const APP_BAR_WIDTHS = {
	COLLAPSED: "w-10",
	EXPANDED: "w-56",
};

// Padding values for the AppBar
export const APP_BAR_PADDING = {
	COLLAPSED: "px-1",
	EXPANDED: "px-1",
};

// Colors for the AppBar
export const APP_BAR_COLORS = {
	BACKGROUND: "bg-stone-100",
	TEXT: "text-gray-700",
	TEXT_HOVER: "text-gray-900",
	HOVER_BG: "hover:bg-gray-200",
	SELECTED_BG: "bg-gray-100",
	SELECTED_OUTLINE: "outline-gray-400",
};

// Icon sizes
export const APP_BAR_ICON_SIZES = {
	DEFAULT: 16,
};

// Animation durations
export const APP_BAR_ANIMATION = {
	DURATION: "duration-300",
};
